import type { VaultThemePreference } from '@nebula/shared-vault/data-access';

export type { VaultThemePreference };

export interface UserPreferences {
  email_notifications: boolean;
  push_notifications: boolean;
  task_reminders: boolean;
  weekly_reports: boolean;
  theme: VaultThemePreference;
  items_per_page: number;
  show_help_tooltips: boolean;
  language: string;
}

export interface SecuritySettings {
  session_timeout_minutes: number;
  password_min_length: number;
  require_uppercase: boolean;
  require_numbers: boolean;
  require_special_chars: boolean;
  two_factor_enabled: boolean;
}

export interface CompanySettings {
  company_name: string;
  retention_policy_days: number;
  auto_backup_enabled: boolean;
}

export const DEFAULT_USER_PREFERENCES: UserPreferences = {
  email_notifications: true,
  push_notifications: true,
  task_reminders: true,
  weekly_reports: false,
  theme: 'light',
  items_per_page: 50,
  show_help_tooltips: true,
  language: 'es',
};

export const DEFAULT_SECURITY_SETTINGS: SecuritySettings = {
  session_timeout_minutes: 30,
  password_min_length: 8,
  require_uppercase: false,
  require_numbers: false,
  require_special_chars: false,
  two_factor_enabled: false,
};

export const DEFAULT_COMPANY_SETTINGS: CompanySettings = {
  company_name: '',
  retention_policy_days: 365,
  auto_backup_enabled: true,
};
